import React,  {Component} from 'react'; 
import MovieListItem from './MovieListItem'
import getBrowserWidth from '../../functions/getBrowserWidth';

export default class MovieListItemContainer extends Component {
    constructor (props) {
        super(props) 
        this.state = {
            // closingDetails: false, // Wird noch verwendet?
            showMobileMovieTimes: false,
            currentDateActive: '',
            currentBrowserWidth: 0,
        }

        this.closeItemDetails = this.closeItemDetails.bind(this)
        this.toggleMovieTimesOnMobileView = this.toggleMovieTimesOnMobileView.bind(this)
        this.toggleMovieDatesOnMobileView = this.toggleMovieDatesOnMobileView.bind(this)
        this.getWidth = this.getWidth.bind(this)
    }

    componentDidMount() {
        this.getWidth()
        this.debouncedGetWidth = _.debounce(this.getWidth, 300)
        window.addEventListener("resize", this.debouncedGetWidth)
    }

    componentWillUnmount() {
        this.debouncedGetWidth.cancel()
        window.removeEventListener("resize", this.debouncedGetWidth)
    }

    componentDidUpdate(prevProps) {
        const { selectionId, activeSelection, activeDetailsItem, onCloseDetails } = this.props

        if (activeSelection !== prevProps.activeSelection) {
            if(activeSelection && activeDetailsItem && activeSelection !== selectionId)  {
                onCloseDetails()
            }
        }
    }

    getWidth() {
        const {currentBrowserWidth} = this.state
        const newBrowserWidth = getBrowserWidth()
        if(currentBrowserWidth !== newBrowserWidth) {
            this.setState({
                currentBrowserWidth: newBrowserWidth
            })
        }
    }

    toggleMovieTimesOnMobileView(date) {
        const {showMobileMovieTimes} = this.state
        
        if(date) {
            this.setState({
                currentDateActive: date,
                showMobileMovieTimes: !showMobileMovieTimes
            })
        } else {
            this.setState({
                currentDateActive: '',
                showMobileMovieTimes: !showMobileMovieTimes
            })
        }
    }

    toggleMovieDatesOnMobileView(date) {        
        this.setState({
            currentDateActive: date
        })
    }

    closeItemDetails(detailsObj) {
        this.props.onCloseDetails(detailsObj)
    }

    render() {
        const { 
            id, 
            activeDetailsItem, 
            itemData, 
            hideCinemaSelector, 
            itemsData, 
            itemLink, 
            isSingleMovie, 
            overviewFilterIgnoreOnPerformances,
            displaySidebarRight, 
            displaySidebarRightSecond, 
            performancePageOpen, 
            activePerformance, 
            onOpenPerformancePage, 
            dayFilters,
            index,
            onClosePerformancePage, 
            queryStringValues, 
            translation, 
            additionalScrollName, 
            onOpenDetails,
            isMobile,
            clusterCinemaActive,
            clusterCinemaOption,
            activeCinema,
            currentCinemaType, 
        } = this.props;
        const {showMobileMovieTimes, currentDateActive, currentBrowserWidth} = this.state
        const isOverview = true
        const detailsOpen = activeDetailsItem === id

        return <MovieListItem 
            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            queryStringValues={queryStringValues}
            isMobile={isMobile}
            index={index}
            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            dayFilters={dayFilters}
            hideCinemaSelector={hideCinemaSelector}
            itemDetailsOpen={detailsOpen}
            scrollToPosition={id + additionalScrollName}
            id={id}
            itemData={itemData}
            currentCinemaType={currentCinemaType}
            itemsData={itemsData}
            itemLink={itemLink}
            translation={translation}
            isOverview={isOverview}
            closingDetails={false} // Wird noch gebraucht???
            isSingleMovie={isSingleMovie}
            showMobileMovieTimes={showMobileMovieTimes}
            toggleMovieTimesOnMobileView={this.toggleMovieTimesOnMobileView}
            toggleMovieDatesOnMobileView={this.toggleMovieDatesOnMobileView}
            openItemDetails={onOpenDetails}
            closeItemDetails={this.closeItemDetails}
            currentBrowserWidth={currentBrowserWidth}
            currentDateActive = {currentDateActive}
            displaySidebarRight={displaySidebarRight}
            displaySidebarRightSecond={displaySidebarRightSecond}
            performancePageOpen={performancePageOpen}
            activePerformance={activePerformance}
            onOpenPerformancePage={onOpenPerformancePage}
            onClosePerformancePage={onClosePerformancePage}
        />
    }
}